// т.к не всегда id страницы и navId совпадают, то в этот плагин можно передать например page_template
// страницы или любой другой id страницы, здесь распарсится дерево страниц по подстраницам this.$store.state.cms.menus

export default (context, inject) => {
  inject('findCmsIdByNavId', (targetId) => {
    const menus = context.store?.state?.cms?.menus;

    if (!menus || typeof menus !== 'object') {
      return null;
    }

    for (const [key, value] of Object.entries(menus)) {
      if (value && Array.isArray(value.items)) {
        const found = value.items.find(item => item && (item.nav_id === targetId || item.navId === targetId) );
        if (found && found.id) {
          return found.id;
        }
      }
    }

    return null;
  });
};